import Field from 'components/Field';
import FormSingle from 'components/FormSingle';
import Input from 'components/Input';
import Label from 'components/Label';
import createReactClass from 'create-react-class';
import Formsy from 'lib/Formsy';
import { isEqual, uniqueId } from 'lodash';
import { InputBlur, FocusEventHandler } from 'types/typescript/eventHandlers';
import React from 'react';
import createChainedFunction from 'utils/createChainedFunction';

type Props = {
  autofocus?: boolean;
  button?: React.ReactNode;
  className?: string;
  /* use a custom component instead of Input */
  component?: React.Component;
  /* custom error message that overrides builtin validation */
  errorMessage?: string;
  label?: string;
  /* hide label */
  labelHidden?: boolean;
  loading?: boolean;
  name?: string;
  /* Execute the callback when a cursor leaves the input field */
  onBlur?: InputBlur;
  /* Execute the callback when the input value changes */
  onChange?: FocusEventHandler;
  /* placeholder text */
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  /* when true it hides the error message until a blur event is emitted, default FALSE */
  showErrorAfterBlur?: boolean;
  /* show error even when no change as been made to the input, default is FALSE */
  showErrorOnPristine?: boolean;
  /* the input type */
  type?: string;
  /* Following validation props used in SetupFullName.tsx, SetupSchoolEmail.tsx, SetupSignature.tsx */
  validations?:
    | {
        maxLength?: number;
        minLength?: number;
      }
    | string;
  validationError?: string;
  validationErrors?: { maxLength: string };
  /* label text */
  value?: string | boolean | undefined;
  warning?: string | HTMLElement;
};

const FormInput = createReactClass<Props>({
  mixins: [Formsy.Mixin],

  getDefaultProps() {
    return {
      showErrorAfterBlur: false,
      showErrorOnPristine: false,
    };
  },

  getInitialState() {
    // Unless type is 'password', trim input value before validation
    return {
      wasBlur: false,
      value: this.props.value,
      formatters:
        this.props.type === 'password'
          ? []
          : [
              (value: string) => {
                return value && value.trim ? value.trim() : value;
              },
            ],
    };
  },

  componentWillMount() {
    this.id = uniqueId('id-');
  },

  componentDidMount() {
    this.interval = setInterval(this.lookForChanges, 1000);
  },

  componentWillReceiveProps(nextProps: Props) {
    if (this.props.value && this.props.value !== nextProps.value) {
      this.changeValue(nextProps.value);
    }
  },

  shouldComponentUpdate(nextProps, nextState) {
    return !(isEqual(this.props, nextProps) && isEqual(this.state, nextState));
  },

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },

  handleBlur() {
    if (this.state.wasBlur === false) {
      this.setState({ wasBlur: true });
    }
  },

  handleChange(event: React.FormEvent<HTMLInputElement>) {
    // Some of our custom components that will be passed in through component
    // call onChange on the value, rather than the event.
    if (event.currentTarget) {
      this.changeValue(event.currentTarget.value);
    } else {
      this.changeValue(event);
    }

    if (this.props.onChange) {
      this.props.onChange(event);
    }
  },

  changeValue(value: string) {
    let formattedValue = value;
    type FormatterType = (formattedValue: string) => string;
    this.state.formatters.forEach((formatter: FormatterType) => {
      formattedValue = formatter(formattedValue);
    });

    this.setValue(formattedValue);
    this.setState({
      // the state always hold the real value.
      value,
      wasBlur: false,
    });
  },

  /* This is for autofill purposes.
   * Some browsers does not emit change event when
   * they fill out the forms, so formzy is not aware
   * the value change and the validation does not run.
   * This pulls the value from the DOM at
   * regular interval and if what is found is different
   * than what formzy currently have then we tell formzy
   * about this new value via the formzy mixin.
   */
  lookForChanges() {
    if (!this.refs.input) {
      return;
    }

    const { value } = this.refs.input.getInputNode();
    if (value && this.getValue() !== value) {
      const event = {
        currentTarget: { value },
        target: { value },
      };
      this.handleChange(event);
    }
  },

  focus() {
    if (this.refs.input.focus) {
      this.refs.input.focus();
    }
  },

  renderLabel() {
    const { label } = this.props;

    if (label) {
      return (
        <Label htmlFor={this.id} hidden={this.props.labelHidden}>
          {label}
        </Label>
      );
    } else {
      return null;
    }
  },

  renderInput() {
    const { button } = this.props;
    const Component = this.props.component || Input;
    const input = (
      <Component
        {...this.props}
        ref="input"
        id={this.id}
        value={this.state.value || ''}
        placeholder={this.props.placeholder}
        onBlur={createChainedFunction(this.props.onBlur, this.handleBlur)}
        onChange={this.handleChange}
      />
    );

    if (button) {
      return (
        <FormSingle>
          {input}
          {button}
        </FormSingle>
      );
    }

    return input;
  },

  render() {
    let errorMessage = this.getErrorMessage();

    if (this.props.showErrorAfterBlur && !this.state.wasBlur) {
      errorMessage = null;
    }

    if (!this.props.showErrorOnPristine && this.isPristine()) {
      errorMessage = null;
    }

    errorMessage = this.props.errorMessage || errorMessage;

    return (
      <Field error={errorMessage} warning={this.props.warning} loading={this.props.loading}>
        {this.renderLabel()}
        {this.renderInput()}
      </Field>
    );
  },
});

export default FormInput;
